/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';

import t from '../../../../../../../../../../css/global.module.css';
import s from './burgerIcon.module.css';


const BurgerIcon = (props) => {
  const width = `${props.width}px`;
  const height = `${props.height}px`;
  const oneThirdHeight = `${Math.ceil(parseInt(height.replace('px', ''), 10) / 3)}px`;

  const isOpen = props.isOpen || false;
  const getTransformValue = (openVal, translateVal, rotateVal) => `translateY(${isOpen ? translateVal : '0'}) rotate(${openVal ? `${rotateVal}deg` : '0'})`;

  const styles = {
    container: {
      width,
      height,
      position: 'relative',
      minWidth: width,
    },
    lineBase: {
      height: `${props.strokeWidth}px`,
      backgroundColor: props.lineColor,
      borderRadius: `${props.borderRadius}px`,
      transformOrigin: 'center',
      transitionTimingFunction: 'ease',
      transitionDuration: `${props.animationDuration}s`,
    },
    LineBaseCtn: {
      height,
      backgroundColor: props.burgerBackgroundColor,
      transform: getTransformValue(isOpen, 0, 135),
      transitionTimingFunction: 'ease',
      transitionDuration: `${props.animationDuration}s`,
      transitionProperty: 'all',
    },
    firstLine: {
      transform: getTransformValue(isOpen, oneThirdHeight, 90),
    },
    secondLine: {
      transitionTimingFunction: 'ease-out',
      transitionDuration: `${props.animationDuration / 4}s`,
      opacity: '1',
    },
    thirdLine: {
      transform: getTransformValue(isOpen, 90),
      transitionDuration: `${props.animationDuration / 10}s`,
      opacity: isOpen ? '0' : '1',
    },
  };

  return (
    <div style={styles.container} className={s.icons}>
      <div style={styles.LineBaseCtn} className={`${t.flex} ${t.pointer} ${t.relative}  ${t['justify-around']} ${t['flex-column']}`}>
        <span className={`${t.db} `} style={Object.assign({}, styles.lineBase, styles.firstLine)} />
        <span className={`${t.db} `} style={Object.assign({}, styles.lineBase, styles.secondLine)} />
        <span className={`${t.db} `} style={Object.assign({}, styles.lineBase, styles.thirdLine)} />
      </div>
    </div>
  );
};

BurgerIcon.propTypes = {
  burgerBackgroundColor: PropTypes.string,
  lineColor: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  strokeWidth: PropTypes.number,
  animationDuration: PropTypes.number,
  borderRadius: PropTypes.number,
};

// configurable props

BurgerIcon.defaultProps = {
  burgerBackgroundColor: 'transparent',
  lineColor: '#777',
  width: 35,
  height: 35,
  strokeWidth: 2,
  animationDuration: 0.4,
  borderRadius: 10,
};

export default BurgerIcon;
